export default "__VITE_ASSET__DNWR2xtQ__"